import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const poaEndpoint = "/api/proyectoEstructuracionTree";

export const getProyectoEstructuracionTree = async (ruta, nivel, nocache = false) => {
  try {
    const params = { ruta, nivel };
    if (nocache) params.nocache = 'true';
    
    const response = await axios.get(`${baseUrl}${poaEndpoint}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener proyectoEstructuracionTree:", error);
    throw error;
  }
};

export const downloadFolder = async (ruta) => {
  try {
    const response = await axios.get(`${baseUrl}${poaEndpoint}/downloadFolder`, {
      params: { ruta },
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    console.error("Error al descargar la carpeta:", error);
    throw error;
  }
};

export const refreshTreeData = async (ruta, nivel) => {
  try {
    // Usar el nuevo endpoint refresh que invalida cache primero
    const response = await axios.get(`${baseUrl}${poaEndpoint}/refresh`, {
      params: { ruta, nivel },
    });
    return response.data;
  } catch (error) {
    console.error("Error al refrescar datos del árbol:", error);
    throw error;
  }
};

export const invalidateCache = async (path = null) => {
  try {
    const response = await axios.post(`${baseUrl}${poaEndpoint}/invalidateCache`, {
      path
    });
    return response.data;
  } catch (error) {
    console.error("Error al invalidar cache:", error);
    throw error;
  }
};